import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import FontAwesomeSvgIcon from "Layouts/Common/FontAwesomeSvgIcon";
import svgFronts from "Layouts/Common/fontAwesome";

interface IDocumentPdfSearchProps {
  onSearchDocumentVersions: (newDocTitle: string) => void;
}

const DocumentPdfSearch: React.FunctionComponent<IDocumentPdfSearchProps> = ({
  onSearchDocumentVersions,
}) => {
  const [documentPdfTitle, setDocumentPdfTitle] = React.useState("");

  const handleOnChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    setDocumentPdfTitle(value);
    onSearchDocumentVersions(value);
  };

  React.useEffect(() => {
    return () => {
      setDocumentPdfTitle("");
    };
  }, [onSearchDocumentVersions]);

  return (
    <TextField
      onChange={handleOnChange}
      value={documentPdfTitle}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FontAwesomeSvgIcon icon={svgFronts.faMagnifyingGlass} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default DocumentPdfSearch;
